import {
  Applicant,
  ApplicantAddressType,
  ApplicationProps,
  JointholderRelationMaster,
} from '../redux-store/types/api-types';
import {
  applicantStatusValueMap,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  BloodRelations,
  BseClientActivationStatusMaster,
  onboardingTypeMasters,
  RoleTypes,
  SALT,
  SALT2,
  USER_ROLES,
} from './constant';
import { ToWords } from 'to-words';
import { numberRegex } from './regex';
import _, { each, isNumber } from 'lodash';
import { RelatedPersonError } from '../redux-store/middleware';
import { updatedRiskProfile } from '../components/investors/riskProfileDetails';
import * as htmlToImage from 'html-to-image';
import { MutableRefObject } from 'react';
import { HistoricalNavItem } from '../redux-store/types/investorProfile';
import dayjs, { Dayjs } from '../utils/dayjs';

export const getUniqueIdentityText = (company: string): { [key: string]: string; } => {
  switch (company) {
    case "WMS":
      return {
        pan: "PAN",
        panCard: "PAN Card",
        panId: "PAN Id",
        panNumber: "PAN Number",
        panNo: "PAN No."

      }
    case "Wealth":
      return {
        pan: "PAN",
        panCard: "PAN Card",
        panId: "PAN Id",
        panNumber: "PAN Number",
        panNo: "PAN No."

      }
    case "PHP":
      return {
        pan: "Tax/Passport ID",
        panCard: "Tax/Passport ID Card",
        panId: "Tax/Passport ID",
        panNumber: "Tax/Passport ID",
        panNo: "Tax/Passport ID"

      }
    default:
      return {
        pan: "PAN",
        panCard: "PAN Card",
        panId: "PAN Id",
        panNumber: "PAN Number",
      }
  }
}

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const getApplicantForBanks = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else if (index == 3) {
    return 'Third';
  } else if (index === 4) {
    return 'Fourth';
  } else {
    return 'Fifth';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => ['firstapplicant', '1'].includes(applicant.applicant_type || ''))
      ?.name || 'N/A'
  );
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export function getEmailPhonePersonRelationType(relation?: string): boolean {
  return [
    'self',
    'spouse',
    'dependent_children',
    'dependent_parents',
    'depending_siblings',
    '',
  ].includes(relation as string);
}

export const formatToIndianCurrency = (value?: number | string | null, amountUnit?: number | null): string => {
  value = Number(value);
  amountUnit = amountUnit ? amountUnit : 0;
  const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'INR' };
  if (value !== (undefined || null) && !isNaN(value)) {
    if (amountUnit == 0) {
      return new Intl.NumberFormat('en-IN', options).format(value);
    }
    else if (amountUnit == 1 && value >= 10000000) {
      value = value / 10000000;
      return new Intl.NumberFormat('en-IN', options).format(value) + ' Cr';
    }
    else {
      value = value / 100000;
      return new Intl.NumberFormat('en-IN', options).format(value) + ' Lakhs';
    }
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0].concat('.', a[1].substr(0, 2));
  }
  return str;
}

export const downloadFile = async (response: any, userId: any, filename = '', fileType = 'pdf') => {
  console.log("response>>>   ", response, "filename>>", filename)

  const day = new Date().getDate().toString().padStart(2, '0');
  const month = (new Date().getMonth() + 1).toString().padStart(2, '0');
  const year = new Date().getFullYear().toString();
  const formattedDate = [day, month, year].join('');
  let blob;
  const link = document.createElement('a');
  if (fileType === 'pdf') {
    const byteArray = new Uint8Array(response);
    blob = new Blob([byteArray], { type: 'application/pdf' });
    link.href = window.URL.createObjectURL(blob);
    link.download =
      'Report_' +
      (filename ? filename + '_' : '') +
      new Date().toLocaleDateString('en-US') +
      '.pdf';
  } else if (fileType === 'xlsx') {
    const byteArray = new Uint8Array(response);
    blob = new Blob([byteArray], {
      type: 'application/vnd.ms-excel; charset=utf-8',
    });
    link.href = window.URL.createObjectURL(blob);
    link.download = userId + '_' + (filename ? filename + '_' : '') + formattedDate + '.xlsx';
  } else if (fileType === 'xls') {
    const byteArray = new Uint8Array(response);
    blob = new Blob([byteArray], {
      type: 'application/vnd.ms-excel; charset=utf-8',
    });
    link.href = window.URL.createObjectURL(blob);
    link.download = userId + '_' + (filename ? filename + '_' : '') + formattedDate + '.xls';
  }
  link.click();
  return response;
};

export const downloadMultipleFiles = (response: any) => {
  console.log("response>>", response)
  if (typeof response === 'string') response = JSON.parse(response);
  if (typeof response === 'object') {
    response.map((each: any) => {
      const userId = Object.keys(each)[0];
      return downloadFile(each[userId].data, userId, each.filename, each.fileType);
    });
  } else {
    const userId = Object.keys(each)[0]
    downloadFile(response, userId);
  }
};

export const formatDate = (date: any) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());

  return `${day}/${month}/${year}`;
};

export const replaceLetterOWithW = (text: string) => {
  return text.split('o').join('W');
};

export const getFromToDates = (value: string): { fromDate: string; toDate: string } => {
  const today = new Date();
  switch (value) {
    case 'previous-fy':
      if (today.getMonth() + 1 <= 3) {
        return {
          fromDate: `01/04/${today.getFullYear() - 2}`,
          toDate: `31/03/${today.getFullYear() - 1}`,
        };
      } else {
        return {
          fromDate: `01/04/${today.getFullYear() - 1}`,
          toDate: `31/03/${today.getFullYear()}`,
        };
      }
    case 'current-fy':
      if (today.getMonth() + 1 <= 3) {
        return {
          fromDate: `01/04/${today.getFullYear() - 1}`,
          toDate: `31/03/${today.getFullYear()}`,
        };
      } else {
        return {
          fromDate: `01/04/${today.getFullYear()}`,
          toDate: `31/03/${today.getFullYear() + 1}`,
        };
      }
    default:
      return {
        fromDate: '',
        toDate: '',
      };
  }
};

export const formatCurrency = ({
  value,
  locale,
  currencyCode
}: {
  value: number;
  locale: string;
  currencyCode: string;
}): string => {

  const modifiedValue = Number(value ?? 0)

  // Checking if value is a valid number
  if (Number.isNaN(modifiedValue)) {
    return "-"
  }

  if (locale === "en-IN") {
    const formatter = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 2,
      trailingZeroDisplay: "stripIfInteger"
    } as any);

    const thresholds = [1e7, 1e5, 1e3];
    const suffixes = ['Cr', 'L', 'K'];

    const index = thresholds.findIndex(threshold => modifiedValue >= threshold);

    const divisor = thresholds[index] ?? 1;
    const formattedAmount = formatter.format(modifiedValue / divisor);

    return `₹ ${formattedAmount + (suffixes[index] || '')}`;
  } else {
    const formatter = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 2,
      trailingZeroDisplay: "stripIfInteger",
      style: "currency",
      currency: currencyCode,
      notation: "compact",
    } as any);

    const result = formatter.formatToParts(modifiedValue)

    const formattedResult = result
      .map(obj => obj.type === "currency" ? obj.value + " " : obj.value)
      .join("")

    return formattedResult
  }

  // const formats = ['K', 'L', 'Cr'];
  // let amount: any = Number(value);
  // formats.some((key, i) => {
  //   const size = Math.pow(10, i === 0 ? 3 : 3 - 1);
  //   if (size <= amount) {
  //     amount = toExactSubstr(`${amount / size}`);
  //     if (amount >= 100 && i < formats.length - 1) {
  //       i++;
  //     } else {
  //       // amount = (amount * decPlaces) / decPlaces;
  //       amount += ' ' + formats[i];
  //       return true;
  //     }
  //   } else {
  //     return true;
  //   }
  // });
  // return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    address1: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    country: addressType === 'overseas' ? '' : 'INDIA',
    pincode: '',
    permanentAddressSameAsCorresponding: false,
    address_type: addressType,
    isActive: true,
    fetchedFromKRA: null,
  };
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null): boolean {
  return ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''].includes(
    relationValue || ''
  );
}

export function getOccupationType(occupation?: string | null): boolean {
  return [
    'Agriculturist',
    'Business',
    'Doctor',
    'Housewife',
    'Professional',
    'Retired',
    'Service',
    'Student',
    '',
  ].includes(occupation || '');
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null,
  isDiyInvestorOnboarding?: boolean
): string => {
  return isDiyInvestorOnboarding ? `/investor-onboarding-application-details/${id}`
    : role === USER_ROLES.INVESTOR
      ? `/investment-details/${applicant1ReferenceId}/application-details`
      : role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
        ? `/application-details/${id}`
        : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};
export const futureAge = (dateOfBirth = ''): boolean => {
  return new Date(dateOfBirth) > new Date();
};

export function currencyConversion(localeCode: string, num?: string | number | null): string | null {
  if (!num) return '';
  const toWords = new ToWords({
    localeCode,
    converterOptions: {
      currency: true,
    }
  });
  const words = toWords.convert(Number(num));
  return words;
}

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any) => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}

export function allowDecimalNumbers(event: any): void {
  if (
    !((event.ctrlKey || event.metaKey) && event.keyCode == 67) //Ctrl+C (Copy)
    && !((event.ctrlKey || event.metaKey) && event.keyCode == 86) //Ctrl+V (Paste)
    && !((event.ctrlKey || event.metaKey) && event.keyCode == 88) //Ctrl+X (Cut)
    && !((event.ctrlKey || event.metaKey) && event.keyCode == 90) //Ctrl+Z (Undo)
    && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(event.key) &&
    !(event.key === '.') &&
    !numberRegex.test(event.key)
  ) {
    event.preventDefault();
  }
}

export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, address3, city, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    address3: address3,
    city: city,
    pincode: pincode,
    state: state,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    applicantStatus?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  const { nationality, status, applicantStatus, ...addressProps } = updatedAddresses;
  const VALID_ADDRESS_TYPES = ['permanent', 'correspondence', 'overseas'];
  return Object.keys(addressProps)
    .filter((addressType) => VALID_ADDRESS_TYPES.includes(addressType))
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: any, isDiyInvOnboardingApplicationPreview = false): boolean => {
  if (isDiyInvOnboardingApplicationPreview && USER_ROLES.INVESTOR) {
    return true
  }

  // return [
  //   USER_ROLES.RM,
  //   USER_ROLES.OPE,
  //   USER_ROLES.OPM,
  //   USER_ROLES.SUBDISTRIBUTOR,
  //   USER_ROLES.DISTRIBUTOR,
  //   USER_ROLES.AMCAPPROVER,
  // ].includes(role);

  return true
};

export const checkKraBasedOnStatus = (status: any): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication: Partial<ApplicationProps> | null,
  updatedApplication: Partial<ApplicationProps>
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  // return application?.applicants.map((applicant) => applicant.status).includes('NRI');
  return (
    (application?.applicants ?? []).map((applicant) => applicant.status).includes('NRE') ||
    (application?.applicants ?? []).map((applicant) => applicant.status).includes('NRO')
  );
};

export const checkForCorrespondenceAddress = (
  applicantStatus: string | null | undefined,
): boolean => {
  return `${applicantStatus ?? ''}`.toLowerCase() === applicantStatusValueMap.individual;
};

export const setUpFeeCalculations = (
  commitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(commitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount),
    feeGst: Number(GstForSetupFee),
    totalSetupFee: Number(setupFeeAmount + GstForSetupFee),
  };
};

export const checkAddressField = (data?: string) => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${address3 ? checkAddressField(address2) || '' : address2 || ''
    }${address3 || ''}`;
};

export const numToAlpMonth = (numMonth: any, month: any) => {
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};

export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

/**
 * Base64-encodes a value using a salted, equals-stripped scheme.
 *
 * NOTE: This uses Buffer.from(value, 'utf8'), which encodes input as UTF-8 bytes.
 * This differs from the browser's btoa(), which operates on Latin1/binary strings
 * and throws (InvalidCharacterError) on any character above U+00FF. For non-ASCII
 * input the two produce DIFFERENT Base64 output: btoa would reject multi-byte chars,
 * whereas Buffer emits the multi-byte UTF-8 sequence. For pure-ASCII input (U+0000–U+007F)
 * the output is identical to btoa, so backward compatibility holds only for ASCII.
 *
 * If this payload is consumed by a service that was built against the old btoa
 * behavior, ensure either (a) only ASCII reaches this function, or (b) the decoder
 * decodes the bytes as UTF-8. Otherwise previously-encoded non-ASCII payloads will
 * not round-trip to the same bytes.
 */
export function encodeBase64(value: string): string {
  const encodeValue = Buffer.from(value, 'utf8').toString('base64');
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = Buffer.from(`${SALT}${encodeSubString}${SALT2}`, 'utf8').toString('base64');
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null): boolean {
  // return ['MOTHER', 'FATHER', 'DAUGHTER', 'SON', 'SPOUSE', 'BROTHER', 'SISTER', ''].includes(
  //   relationValue || ''
  // );
  return [
    "FATHER",
    "MOTHER",
    "HUSBAND",
    "SPOUSE",
    "GRANDFATHER",
    "GRANDMOTHER",
    "SISTER",
    "DAUGHTER",
    "SELF",
    "BROTHER",
    "SON",
    "DAUGHTER IN LAW",
    ''].includes(
      relationValue || ''
    );
}

export function updatedCommitmentAmount(
  minCommitmentAmount: number,
  applicants: Partial<Applicant>[],
  data: JointholderRelationMaster
): number | void {
  if (applicants.length === 2) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele)
      ?.toString();
    const relation = BloodRelations.includes(applicantRelation) ? applicantRelation : 'Others';
    const amount = data.singleJointHolder
      .map((jointHolder) => {
        if (jointHolder.jointHolder1RelationShip === relation) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
  if (applicants.length === 3) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele);
    const relation = applicantRelation.map((_relation) =>
      BloodRelations.includes(_relation as string) ? _relation : 'Others'
    );
    const amount = data.twoJointHolders
      .map((jointHolder) => {
        if (
          relation[applicants.length - 3] === jointHolder.jointHolder1RelationShip &&
          relation[applicants.length - 2] === jointHolder.jointHolder2RelationShip
        ) {
          return (minCommitmentAmount * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Number(amount);
  }
}

export const relatedPersonPanValidation = (applicants: Partial<Applicant>[], company = "WMS") => {
  applicants.map((applicant, ind) => {
    const { relatedpersons = [] } = applicant;
    const activeRelatedPersons = relatedpersons.filter((_item) => _item.isActive);
    if (activeRelatedPersons.length) {
      activeRelatedPersons.map((person, index) => {
        if (
          person.panNo &&
          activeRelatedPersons.filter((relatedPerson) => relatedPerson.panNo === person.panNo)
            .length !== 1
        ) {
          throw new RelatedPersonError(
            `Duplicate ${getUniqueIdentityText(company)?.pan} Number found in Details of Related Person of ${getApplicantName(
              ind + 1
            )} Applicant`
          );
        }
        if (person.panNo === applicant.panNo) {
          throw new RelatedPersonError(
            `Applicant ${getUniqueIdentityText(company)?.pan} not allowed to enter as Related Person ${getUniqueIdentityText(company)?.pan} in Details of Related Person of ${getApplicantName(
              ind + 1
            )} Applicant`
          );
        }
      });
    }
  });
};

export const changeGoalVal = (
  ans: string,
  riskProfileData: updatedRiskProfile[],
  question: string
) => {
  const ansArray = ans?.split('*').map((val) => {
    const index = val?.indexOf('_');
    const result = val?.substring(0, index);
    return result;
  });
  const valueArray = riskProfileData?.find((profile) => profile.question === question)?.values;
  const labelsArray = ansArray?.map((key) => {
    const item = valueArray?.find((val) => val.key === key);
    return item ? `${item.label}` : null;
  });
  return labelsArray;
};

export const getAge = (Dob: string | null | undefined) => {
  let age;
  if (Dob) {
    const birthDate = new Date(Dob);
    const currentDate = new Date();
    const difference = currentDate.getTime() - birthDate.getTime();
    age = difference / (1000 * 60 * 60 * 24 * 365.25);
  }
  return age;
};

export const getRiskAgeValue = (age: number | undefined) => {
  if (age) {
    age = Math.round(age);
    if (age >= 0 && age <= 35) {
      return 'between0to35years';
    } else if (age >= 36 && age <= 45) {
      return 'between36to45years';
    } else if (age >= 46 && age <= 60) {
      return 'between46to60years';
    } else if (age >= 61 && age <= 70) {
      return 'between61to70years';
    } else {
      return 'morethan70years';
    }
  }
  return '';
};

export const getScore = (key: string) => {
  if (key === 'between0to35years') {
    return '50';
  } else if (key === 'between36to45years') {
    return '40';
  } else if (key === 'between46to60years') {
    return '30';
  } else if (key === 'between61to70years') {
    return '20';
  } else if (key === 'morethan70years') {
    return '10';
  }
  return '';
};

export function applicationDownloadStatusCheck(status: string): boolean {
  return APPLICATION_LISTING_STATUS[status] !== APPLICATION_LISTING_STATUS.completed;
}

export const isOnboardingTypeMinor = (onBoardingType: string): boolean => {
  if (onboardingTypeMasters[onBoardingType] === onboardingTypeMasters.minor) {
    return true;
  } else {
    return false;
  }
};

export const getBseClientActivationStatus = (bseClientActivationStatus: string): boolean => {
  return (
    BseClientActivationStatusMaster[bseClientActivationStatus || ''] ===
    BseClientActivationStatusMaster.pending
  );
};

export const copyGraphToClipboard = async (
  graphRef: MutableRefObject<HTMLElement>
): Promise<void> => {
  const divElement = graphRef.current;
  const _window = window as any;
  try {
    const dataUrl = await htmlToImage.toPng(divElement, {
      height: divElement.scrollHeight,
      style: {
        backgroundColor: 'white',
        transform: `translateY(-${divElement.scrollTop}px)`,
      },
    });

    const blob = await fetch(dataUrl).then((res) => res.blob());
    if (navigator.clipboard && navigator.clipboard.write) {
      const item = new ClipboardItem({ [blob.type]: Promise.resolve(blob) });
      const clipboardItems = [item];
      const writePromises = clipboardItems.map((clipboardItem) =>
        navigator.clipboard.write([clipboardItem])
      );
      await Promise.all(writePromises);
      console.log('Image copied to clipboard');
      return Promise.resolve();
    } else {
      // console.error('Clipboard write API not available');
      const imgData = dataUrl.replace(/^data:image\/(png|jpg);base64,/, '');
      const clipboardData = _window.clipboardData || new DataTransfer();
      clipboardData.setData('text/plain', '');
      clipboardData.setData('text/html', divElement.outerHTML);
      clipboardData.setData('image/png', imgData);
      _window.clipboardData ? _window.clipboardData.setData('Text', divElement.outerHTML) : null;
      document.execCommand('copy');
      console.log('Image copied to clipboard');
      return Promise.resolve();
    }
  } catch (error) {
    console.error('Failed to copy image: ', error);
    return Promise.reject();
  }
};

export function capitalize(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const rmRoleTypeService = (roleType: string): boolean => {
  return RoleTypes[roleType] === RoleTypes.support_rm;
};

export function formatFileSize(bytes: number | string, decimalPoint = 2): string {
  const bytesNumber = Number(bytes);
  if (!bytesNumber || bytesNumber <= 0) return '0 B';

  const k = 1000;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytesNumber) / Math.log(k));

  return parseFloat((bytesNumber / Math.pow(k, i)).toFixed(decimalPoint)) + ' ' + sizes[i];
}

export function getAbbreviatedCharactors(fullName: string): string {
  const nameParts = fullName?.split(' ');
  let abbreviatedName = nameParts?.[0]?.charAt(0)?.toUpperCase();
  if (nameParts?.length > 1) {
    abbreviatedName += nameParts?.[1]?.charAt(0)?.toUpperCase();
  }
  return abbreviatedName;
}

export function toINR({
  value,
  locale,
  currencyCode,
}: {
  value: number | string;
  locale: string;
  currencyCode: string
}): string {
  const numValue = !Number.isNaN(Number(value ?? 0)) ? Number(value ?? 0) : 0;

  // if (!numValue) {
  //   return "₹ 0"
  // }

  // return new Intl.NumberFormat("en-IN", {
  //   style: "currency",
  //   currency: "INR",
  //   minimumFractionDigits: 0
  // }).format(numValue).replace("₹", "₹ ")

  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0
  } as any);

  const result = formatter.formatToParts(numValue)

  const formattedResult = result
    .map(obj => obj.type === "currency" ? obj.value + " " : obj.value)
    .join("")

  return formattedResult
}

export function formatNumberWithRupeeSymbol(number: number, locale: string, currencyCode: string) {
  if (!isNumber(number)) return 0

  const formatter = Intl.NumberFormat(locale, {
    notation: "compact",
    style: "currency",
    currency: currencyCode
  })

  const result = formatter.formatToParts(number)

  const formattedResult = result
    .map(obj => obj.type === "currency" ? obj.value + " " : obj.value)
    .join("")

  return formattedResult
}

export const findRiskTolerance = (riskProfile: string) => {
  switch (riskProfile) {
    case 'AGGRS':
    case 'AGGRESSIVE':
      return 'Aggresive';
      break;

    case "ASSERT":
    case "ASSERTIVE":
      return "Assertive";
      break;

    case "BALNSD":
    case "BALANCED":
      return "Balanced";
      break;

    case "CONSV":
    case "CONSERVATIVE":
      return 'Conservative';
      break;

    case "DEFNS":
    case "DEFENSIVE":
      return 'Defensive';
      break;

    default:
      return "Balanced";
  }
}

export const calculateOthersInPieChart = (data: any) => {
  const modifiedData = {
    ...data,
    data: data?.labelOrderEnabled ? data?.data ?? [] : data?.data?.sort((a: [string, number], b: [string, number]) => b[1] - a[1]) ?? [],
    labelData: data?.labelOrderEnabled ? data?.labelData ?? [] : data?.labelData?.sort(
      (a: { label: string; value: number; }, b: { label: string; value: number; }) =>
        b.value - a.value) ?? []
  }

  if (modifiedData?.labelData?.length <= 5) {
    return modifiedData
  } else {

    const lable1 = modifiedData?.labelData?.slice(0, 5)
    const lable2 = modifiedData?.labelData?.slice(5, -1).reduce((acc: any, curr: any) => {
      return {
        label: 'Others',
        value: acc.value + curr.value
      }
    }, { label: 'Others', value: 0 })

    // console.log(data?.data)

    const chartdata1 = modifiedData?.data?.slice(0, 5)
    const chartdata2 = modifiedData?.data?.slice(5, -1).reduce((acc: any, curr: any) => {
      return ['Others', acc[1] + curr[1]]
    }, ['Others', 0])

    // console.log(chartdata1, chartdata2)


    return { ...modifiedData, labelData: [...lable1, lable2], data: [...chartdata1, chartdata2] }
    // return { ...modifiedData, labelData: [...lable1], data: [...chartdata1] }
  }
}

export const filterDataPointsForNav = (dataPoints: Array<HistoricalNavItem>, timeRange: string): any => {
  const now = new Date();
  let startDate: any;
  switch (timeRange) {
    case '1M':
      startDate = new Date(now);
      startDate.setDate(1); // Normalize the day to prevent truncation
      startDate.setMonth(now.getMonth() - 1);
      break;
    case '6M':
      startDate = new Date();
      startDate.setMonth(now.getMonth() - 6);
      break;
    case '1Y':
      startDate = new Date();
      startDate.setFullYear(now.getFullYear() - 1);
      break;
    case '3Y':
      startDate = new Date();
      startDate.setFullYear(now.getFullYear() - 3);
      break;
    case '5Y':
      startDate = new Date();
      startDate.setFullYear(now.getFullYear() - 5);
      break;
    case 'Inception':
      break;
    default:
      throw new Error('Invalid time range');
  }

  return timeRange === 'Inception' ? dataPoints : dataPoints.filter(point => {
    const [timestamp] = point;
    return new Date(timestamp) >= startDate;
  });

};

const imagesAvailable = ['4', '8', '10', '11', '14', '19', '21', '24', '25', '26', '27', '28', '181', '187', '218', '302', '308', '311', '312', '317', '319', '327', '339', '8799', '8927', '9054', '9055', '9521', '10157', '11141', '12160', '12232', '12751', '12931', '13005', 'baroda_MF', 'boi_MF', 'escorts_MF', 'idbi_MF', 'idfc_MF', 'iifl_MF', 'indiabulls_MF', 'iti_MF', 'Int_MF', "9636", "298", "bdotr", "bpiamc"];

export const checkImageExists = (id: any): boolean => {
  // console.log('id', id);
  return imagesAvailable.includes(id ?? '');
};


export const maskInfo = (data: string) => {
  // if (typeof data !== "string" || !data) {
  //   return data
  // }

  // return data?.split(' ').map((str) => {
  //   if (str?.length < 3) {
  //     return str
  //   }
  //   const firstLetter = str?.charAt(0);
  //   const lastLetter = str?.charAt(str?.length - 1);
  //   const asterisks = '*'?.repeat(str?.length - 2);

  //   return firstLetter + asterisks + lastLetter;
  // })?.join(' ')

  return data
}

export const performanceLegendColors = ["#3C92DC", "#852538", "#00B8D9", "#065536", "#f79009"]

export function addYearsAndSubtractOneDay(date: any, yearsToAdd = 40): Dayjs {
  return dayjs(date).add(yearsToAdd, 'year').subtract(1, 'day');
}

export function isModuleAllowed(
  {
    value,
    compareArr,
    objKey = ""
  }: {
    value: string,
    compareArr: Array<Record<string, string>> | Array<string>,
    objKey?: string // in case compareArr is an array of objects
  }
): boolean {

  if (!value || !(compareArr ?? []).length) {
    return false
  }

  if (`${value ?? ""}`.toLowerCase() === "analyticsdashboard") {
    return false
  }

  const modifiedValue = `${value ?? ""}`.toLowerCase();

  const modifiedCompareArr = (compareArr ?? []).map((item: string | Record<string, string>) => {

    if (typeof item === "string") {
      return `${item ?? ""}`.toLowerCase();
    }

    return `${item?.[objKey ?? ""] ?? ""}`.toLowerCase();
  });

  return modifiedCompareArr.includes(modifiedValue);
}

export const getDisplayRiskLabel = (riskType: string): string => {
  if (!riskType) return "";
  return /risk/i.test(riskType) ? riskType : `${riskType} Risk`;
};

export const getDailyFreqInstallmentsMsg = (installments: string | number | null): string => {
  return `In case of DAILY frequency, please ensure the minimum number of installments should be ${installments ?? 0}, excluding holidays.`
}

// Helper: pushes a given date forward to the next working day (Mon–Fri),
// skipping Saturday (dayjs day() === 6) and Sunday (dayjs day() === 0).
// If the date already falls on a working day it is returned unchanged.
export const skipToNextWorkingDay = (date: dayjs.Dayjs): dayjs.Dayjs => {
  let workingDate = date;
  // dayjs().day() => 0 = Sunday, 6 = Saturday. Keep advancing until it is a weekday.
  while (workingDate.day() === 0 || workingDate.day() === 6) {
    workingDate = workingDate.add(1, "day");
  }
  return workingDate;
};

// Helper: advances a date by exactly N working days (Mon–Fri), skipping weekends.
// e.g. Thursday + 3 working days = Tuesday (skips Sat & Sun).
// Note: public/bank holidays are intentionally not excluded here — holiday
// handling is out of scope for the SIP date requirement.
export const addWorkingDays = (date: dayjs.Dayjs, days: number): dayjs.Dayjs => {
  let result = date;
  let remaining = days;
  while (remaining > 0) {
    result = result.add(1, "day");
    if (result.day() !== 0 && result.day() !== 6) {
      remaining--;
    }
  }
  return result;
};

// Determines the next valid SIP (Systematic Investment Plan) date based on the allowed investment dates and whether it's the investor's first order

// invDates - Array of valid day-of-month numbers the investor can choose for SIP (e.g. [1, 5, 10, 15, 20, 25])
// firstOrderFlag - Whether this is the investor's first SIP order (true = first order)
export const findNextValidDate = (invDates: number[], firstOrderFlag: boolean) => {
  // If mandate is already active, the earliest possible SIP date is 3 working days from today
  const activeMandateDate = addWorkingDays(dayjs(), 3);

  // If mandate is pending (new registration), earliest possible SIP date is 31 days from today
  const pendingMandateDate = dayjs().add(31, "days");

  let pushedDate = null;

  // If it's the investor's first order, use the pending mandate buffer (31 days)
  // because a new mandate needs to be set up before the SIP can start.
  if (firstOrderFlag) pushedDate = pendingMandateDate
  // Otherwise, use the active mandate buffer (3 working days) since mandate is already in place
  else {
    pushedDate = activeMandateDate;
  }

  // Fallback: if pushedDate is somehow still null, default to active mandate date (3 working days out)
  if (!pushedDate) {
    pushedDate = activeMandateDate;
  }

  // When it is NOT the first order, SIP can only be placed on working days (Mon–Fri).
  // activeMandateDate is computed by addWorkingDays() which already guarantees a Mon–Fri
  // result — no further skipToNextWorkingDay() is needed and calling it would be redundant.
  // Note: skipToNextWorkingDay() is a shared utility still used by other parts of the
  // codebase (e.g. date pickers); it is intentionally kept exported here.
  // (The firstOrder path uses a plain 31-day calendar add, which may land on a weekend,
  //  but first orders are not subject to the working-day constraint so no skip is applied.)

  // If no specific investment dates are configured for this fund,
  // return the pushed date as-is (any day is valid).
  // For non-first orders, pushedDate = addWorkingDays(today, 3) which always
  // returns a Mon–Fri date by construction — no separate snapping step is needed.
  if (!invDates.length) {
    return pushedDate;
  }

  // Get the day-of-month from the earliest allowed date
  const pushedDay = pushedDate.date();

  // Case 1: Try to find a valid investment day in the SAME month.
  // Consider every allowed day that is on or after the pushed day (sorted ascending)
  // so that if the earliest one lands on a weekend (for non-first orders) we can
  // still pick a later working day within the same month before moving on.
  const sameMonthDays = invDates.filter((d) => d >= pushedDay).sort((a, b) => a - b);

  for (const nextDay of sameMonthDays) {
    // Set the date to that valid day within the same month
    const candidate = pushedDate.date(nextDay);

    // Verify the candidate is still in the same month
    // (e.g., setting day 31 in a 30-day month would roll to next month)
    if (candidate.month() !== pushedDate.month()) {
      continue;
    }

    // For non-first orders, only allow working days. If the candidate falls on a
    // weekend, skip it and try the next allowed day (or fall through to next month).
    if (!firstOrderFlag && (candidate.day() === 0 || candidate.day() === 6)) {
      continue;
    }

    return candidate;
  }

  // Case 2: No valid day found in the current month, so search future months.
  // monthCursor starts at the NEXT month. This is safe because the same-month loop
  // above already evaluated every invDate >= pushedDay in the current month (sorted
  // ascending) and skipped any that fell on weekends. There is no valid current-month
  // candidate left to miss — the loop exhausted them all before falling through here.
  let monthCursor = pushedDate.add(1, "month");

  // Safety limit: search up to 12 months ahead to avoid infinite loops
  let maxIterations = 12;

  // Iterate allowed days in ascending order so we return the earliest valid date.
  const sortedInvDates = [...invDates].sort((a, b) => a - b);

  while (maxIterations > 0) {
    // Try each allowed investment day in this month
    for (const d of sortedInvDates) {
      const candidate = monthCursor.date(d);

      // Check the day didn't overflow into the next month
      // (e.g., Feb 30 would become Mar 2 — we skip those)
      if (candidate.month() === monthCursor.month()) {
        // For non-first orders, skip weekend candidates (Sat/Sun) and keep looking.
        if (!firstOrderFlag && (candidate.day() === 0 || candidate.day() === 6)) {
          continue;
        }
        return candidate; // Found the earliest valid working date in a future month
      }
    }

    // No valid day in this month either, move to the next month
    monthCursor = monthCursor.add(1, "month");
    maxIterations--;
  }
};


